@if (isLoading) {
  <app-skeleton [style]="skeletonRowClasses + '-table'" [count]="skeletonRowInstances"></app-skeleton>
}
@if (_items.length > 0 && !isLoading) {
  <table
    id="{{ renderMode }}"
    class="simple-table"
    [ngClass]="[tableClasses, canReorder ? 'draggableRows' : '']"
    cdkDropList
    (cdkDropListDropped)="drop($event)"
    [cdkDropListDisabled]="!canReorder"
    (scroll)="hideDropDown($event)"
  >
    <tbody class="scrollable-container">
      <tr class="simple-table-header-row">
        @for (column of _columnHeadings; track column.column.title) {
          <th
            class="simple-table-cell"
            [ngStyle]="{
              width: column.column.width,
              'text-align': column.column.align,
              cursor: column.column.sortFunction ? 'pointer' : 'default',
            }"
            [ngClass]="{
              sortable: column.column.sortFunction,
              'sort-asc': column.sortDirn === 1 && lastColumnSorted == column,
              'sort-desc': column.sortDirn === 2 && lastColumnSorted == column,
            }"
            (click)="columnClick(column)"
          >
            <span class="sort-grid">
              {{ column.column.title }}
              <mat-icon fontIcon="north" class="sort-icon"></mat-icon>
            </span>
          </th>
        }
        @if (canReorder) {
          <th class="simple-table-cell"></th>
        }
      </tr>
      @for (item of _items; track item.index; let index = $index) {
        <tr
          class="simple-table-row"
          [ngStyle]="{ display: item.visible ? 'table-row' : 'none' }"
          [ngClass]="rowClassBuilder(item.row)"
          cdkDrag
          [attr.tabindex]="isRowFocusable(item.row) ? 0 : null"
          (keydown.enter)="rowKeyActivate($event, item.row)"
          (keydown.space)="rowKeyActivate($event, item.row)"
        >
          @for (cell of item.row.cells; track $index; let i = $index) {
            <td
              class="simple-table-cell"
              [ngStyle]="{ 'text-align': _columnHeadings[i].column.align }"
              (click)="itemClick(item.row)"
              (dblclick)="itemDoubleClick($event, item.row)"
            >
              <div>
                <!--          AJ: what is this icon and why is it here?-->
                <!--          <i *ngIf="cell.text" class="material-icons merged-icon">merge_type</i>-->
                @if (cell.checkbox) {
                  <input type="checkbox" [checked]="cell.checkbox.checked" />
                }
                @if (cell.icon) {
                  @if (cell.iconUrl) {
                    <app-salesforce-entity-icon
                      [iconUrl]="cell.iconUrl"
                      [iconColor]="cell.iconColor"
                      [iconClass]="cell.icon"
                      [tooltip]="cell.tooltip"
                      imgClass="cell-icon-img">
                    </app-salesforce-entity-icon>
                  } @else {
                    <i class="{{ cell.icon }}" [matTooltip]="cell.tooltip" matTooltipShowDelay="500"></i>
                  }
                }
                @if (cell.autoIcon) {
                  <app-filetype-icon [value]="cell.fileExtension || cell.text"> </app-filetype-icon>
                }
                @if (cell.text) {
                  <span>{{ cell.text }}</span>
                }
                @for (action of cell.actions; track $index) {
                  <span class="action-icon icon-button">
                    @if (isDropDown(action)) {
                      <span class="action-icon icon-button"
                        ><mat-icon
                          fontIcon="arrow_drop_down"
                          (click)="dropClick($event, action, item.row); $event.stopPropagation()"
                          tabindex="0"
                          (keydown.enter)="dropClick($event, action, item.row); $event.stopPropagation()"
                        ></mat-icon
                      ></span>
                    } @else {
                      @if (action.icon.length > 0) {
                        <mat-icon
                          class="{{ action.iconClasses }}"
                          [fontIcon]="action.icon"
                          [ngClass]="{ 'disabled-action': action.disabled }"
                          (click)="!action.disabled ? itemActionClick($event, item.row, action) : null"
                          [matTooltip]="action.title"
                          matTooltipShowDelay="500"
                          [attr.tabindex]="action.disabled ? -1 : 0"
                          (keydown.enter)="!action.disabled ? itemActionClick($event, item.row, action) : null"
                        ></mat-icon>
                      } @else {
                        <span
                          class="fixed-button"
                          [matTooltip]="action.title ? action.title : ''"
                          matTooltipShowDelay="500"
                          matTooltipPosition="right"
                          (click)="itemActionClick($event, item.row, action)"
                          tabindex="0"
                          (keydown.enter)="itemActionClick($event, item.row, action)"
                          >{{ action.title }}</span
                        >
                      }
                    }
                  </span>
                }
              </div>
            </td>
          }
          @if (canReorder) {
            <td class="simple-td-container">
              <span class="reorder-icons">
                <mat-icon
                  class="reorder-up"
                  fontIcon="expand_less"
                  [matTooltip]="'Move file up'"
                  matTooltipShowDelay="500"
                  (click)="reorder(index, index - 1); $event.stopPropagation()"
                  tabindex="0"
                  (keydown.enter)="reorder(index, index - 1); $event.stopPropagation()"
                ></mat-icon>
                <mat-icon
                  class="reorder-down"
                  fontIcon="expand_more"
                  [matTooltip]="'Move file down'"
                  matTooltipShowDelay="500"
                  (click)="reorder(index, index + 1); $event.stopPropagation()"
                  tabindex="0"
                  (keydown.enter)="reorder(index, index + 1); $event.stopPropagation()"
                ></mat-icon>
              </span>
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
}
@if (!hide) {
  <div
    #dropdowncontainer
    style="
      position: fixed;
      z-index: 100;
      background-color: white;
      top: 0;
      padding: 4px;
      border: solid;
      border-width: 1px;
      border-color: lightgrey;
      border-radius: 4px;
    "
  >
    <span><!-- DO NOT REMOVE THIS SPAN --></span>
  </div>
}
